import React, { useEffect, useState } from 'react';
import { IoClose } from "react-icons/io5";
import BarcodeScanner from '../../components/sales_rep/BarcodeScanner';

const SalesRepDashboard = () => {

    const [scanning, setScanning] = useState(false);// Reference to Quagga instance
    const [barcode, setBarcode] = useState('');
    const [productInfo, setProductInfo] = useState([])
    const [total, setTotal] = useState(0);

    const getBarcodeDetails = (barcodeId) => {
        if (barcodeId !== "") {
            let qty = 1
            let price = 1200
            let totalPrice = 0
            // for (let i = 0; i < productInfo.length; i++) {
            //     if (productInfo[i].id && productInfo[i].id === barcodeId) {
            //         qty++
            //     }
            // }
            totalPrice = price * qty
            setProductInfo([...productInfo, { id: barcodeId, qty: qty, product: `product - ${barcodeId}`, price: price, totalPrice: totalPrice }])
        }
    }

    const startScanning = () => {
        setScanning(true);
    };

    const stopScanning = () => {
        setScanning(false);
        setBarcode('')
        setProductInfo([])
        setTotal(0)
    };

    const printDiv = () => {
        const printableContent = document.getElementById('printable-content').innerHTML;
        const tempCont = document.createElement('div');
        tempCont.style.position = 'absolute';
        tempCont.style.zIndex = '1000000';
        tempCont.style.top = '0px';
        tempCont.style.left = '0px';
        tempCont.style.width = '100%';
        tempCont.style.height = '100%';
        tempCont.style.backgroundColor = 'white';
        tempCont.innerHTML = printableContent;
        document.body.appendChild(tempCont);
        window.print();
        document.body.removeChild(tempCont);
    };

    const handleCheckout = () => {
        printDiv(); // Call the print function
        // window.location.reload(); // Reload the page after printing
        stopScanning()
    };

    useEffect(() => {
        getBarcodeDetails(barcode)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [barcode])

    useEffect(() => {
        let sum = 0;
        for (let i = 0; i < productInfo.length; i++) {
            sum += productInfo[i].totalPrice;
        }
        setTotal(sum);
    }, [productInfo]);

    return (
        <>
            <div className=" p-4">
                <button onClick={startScanning} className=" border-2 border-tripstore-black text-tripstore-black hover:bg-tripstore-black hover:text-white">Generate Sales</button>
            </div>
            {scanning &&
                <div className=" absolute top-0 left-0 z-30 w-full h-full bg-black/70 flex justify-center items-center">
                    <div className=" p-8 rounded-lg bg-white w-[95%] max-w-[500px] relative max-h-[90%] overflow-y-scroll scrollbar no-scrollbar">
                        <div onClick={stopScanning} className=" fixed top-4 right-4 text-3xl text-white hover:text-red-500 cursor-pointer"><IoClose /></div>
                        <BarcodeScanner setBarcode={setBarcode} />
                        <p className=' text-center w-full truncate overflow-hidden'>{barcode}</p>
                        <div className=" mt-2 border-2 rounded-md p-2 border-slate-300 text-sm" id="printable-content">
                            <table className=' w-full'>
                                <thead className=' font-semibold border-b-2 border-slate-300'>
                                    <tr>
                                        <td>Qty</td>
                                        <td>Product</td>
                                        <td>Price</td>
                                    </tr>
                                </thead>
                                <tbody className=' border-b-2 border-slate-300'>
                                    {
                                        (productInfo.length > 0) ?
                                            productInfo.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.qty}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.price}</td>
                                                </tr>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan={1000} className=' text-center text-gray-500 font-semibold'>No Item</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                            <div className=" mt-2 flex gap-2 justify-between flex-wrap">
                                <div className="">
                                    <div className=" font-semibold">RATE</div>
                                    <div className="">7.50%</div>
                                </div>
                                <div className="">
                                    <div className=" font-semibold">VAT</div>
                                    <div className="">NGN {(total / 100) * 7.5}</div>
                                </div>
                                <div className="">
                                    <div className=" font-semibold">TOTAL</div>
                                    <div className="">NGN {total - ((total / 100) * 7.5)}</div>
                                </div>
                            </div>
                            <div className=" my-2 h-[2px] bg-slate-300"></div>
                            <div className=" flex gap-2 justify-between flex-wrap">
                                <div className=" font-semibold">TOTAL</div>
                                <div className="">NGN {total}</div>
                            </div>
                        </div>
                        <div className=" mt-4">
                            <button onClick={handleCheckout} className=' bg-tripstore-black text-white w-full'>Check Out</button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default SalesRepDashboard;
